import { FC } from 'react';
import ThemeProvider from '../../../../theme/ThemeProvider';
import { Themes } from '../../../../types';
import { SMPText } from '../../atoms/SMPText';
import { SMPFlex } from '../../atoms/SMPFlex';

type Properties = {
  dataTheme?: Themes | null;
  themes?: { dark?: unknown; light?: unknown; client?: unknown };
};

const FallbackError: FC<Properties> = ({ dataTheme, themes }) => {
  // stiches bug
  const styles = {
    backgroundColor: dataTheme === 'light' ? '#f5f5f5' : 'black',
    color: dataTheme === 'light' ? '#262626' : 'white',
    height: '300px',
  };

  return (
    <ThemeProvider isLoading={false} dataTheme={dataTheme} themes={themes}>
      <SMPFlex style={styles} align={'center'} justify={'center'}>
        <SMPText>Something went wrong!</SMPText>
      </SMPFlex>
    </ThemeProvider>
  );
};

export default FallbackError;
